/* ============================================================
   Crash reporting — Sentry's browser SDK, the web twin of app/src/sentry.ts
   and configured by the same rules: errors only, no PII, off in development.
   Initialised as a side effect of importing this module, which main.tsx does
   FIRST, so a throw while the rest of the module graph evaluates is caught.

   THE DSN IS NOT A SECRET (a write-only ingest endpoint); it is just
   deployment-specific, so it rides in .env as VITE_SENTRY_DSN. Absent = off,
   silently — a reporting layer that breaks the app it reports on is worse than
   none. Source maps are uploaded at build time by @sentry/vite-plugin when
   desktop/.sentry.env provides the token (see vite.config.ts).
   ============================================================ */
import * as Sentry from '@sentry/react';

const dsn: string = import.meta.env.VITE_SENTRY_DSN ?? '';

export const sentryEnabled: boolean = dsn !== '' && !import.meta.env.DEV;

if (dsn !== '') {
  Sentry.init({
    dsn,
    enabled: sentryEnabled,
    environment: import.meta.env.DEV ? 'development' : 'production',
    // the build's content hash doubles as the release, matching the source maps
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0,
    sendDefaultPii: false,
    // This app's content is somebody's personal list; breadcrumbs from the
    // console would carry whatever was ever logged.
    integrations: (defaults) => defaults.filter((i) => i.name !== 'Breadcrumbs'),
  });
}

export const ErrorBoundary = Sentry.ErrorBoundary;
